module.exports = __webpack_public_path__ + "static/media/UC Compound Cam 01-mobile.6f554e43.webp";